// start:ng42.barrel
import './confirmation-popup.controller';
import './please-wait-popup.controller';
import './team-club-picker-popup.controller';
// end:ng42.barrel

